export default __webpack_public_path__ + "static/media/q20.31b71985.png";